// src/components/HeartbeatIndicator.tsx
import React, { useEffect, useRef, useState } from 'react';
import { useSimulationStore } from '../../store/useSimulationStore';

const HeartbeatIndicator: React.FC = () => {
   const tick         = useSimulationStore(s => s.tick);       // or whatever your heartbeat counter is called
   const [beat, setTick] = useState(false);
   const [now,  setNow]  = useState(new Date());
   const prevTick = useRef(tick);
   
   // Pulse on each new tick
   useEffect(() => {
      if (tick === prevTick.current) return;
      prevTick.current = tick;
      setTick(true);
      const t = setTimeout(() => setTick(false), 400);
      return () => clearTimeout(t);
   }, [tick]);
   
   // Live clock — updates every second
   useEffect(() => {
      const id = setInterval(() => setNow(new Date()), 1000);
      return () => clearInterval(id);
   }, []);
   
   const timeStr = now.toLocaleTimeString('en-GB', {
      hour:   '2-digit',
      minute: '2-digit',
      second: '2-digit',
   });
   
   return (
      <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-900 border border-gray-800 rounded-xl">
         {/* Beating dot */}
         <span className="relative flex items-center justify-center w-3 h-3">
        {beat && (
           <span className="absolute inline-flex w-full h-full rounded-full bg-green-400 opacity-60 animate-ping" />
        )}
            <span className={`relative inline-flex w-2 h-2 rounded-full transition-colors duration-150 ${
               beat ? 'bg-green-400' : 'bg-green-600'
            }`} />
      </span>
         
         {/* Tick counter */}
         <span className="text-xs font-mono text-gray-400">
        tick <span className="text-green-400">{tick}</span>
      </span>
         
         {/* Divider */}
         <span className="text-gray-700 text-xs">|</span>
         
         {/* Live clock */}
         <span className="text-xs font-mono text-gray-400">{timeStr}</span>
      </div>
   );
};

export default HeartbeatIndicator;
